<template>
 <OffersForm :layout="'edit'"></OffersForm>
</template>

<script>
import OffersForm from "../components/OffersForm/OffersForm.vue";

export default {
  name: "OffersEdit",
  components: {
    OffersForm
  }

}

</script>